import gql from 'graphql-tag'

export default gql`
mutation CA_web_updateAutomationTaskServerEnability($id: ID!, $isActive: Boolean!, $typeId: ID!) {
	cashAssist {
		updateAutomationTaskServerEnability(id: $id, isActive: $isActive, typeId: $typeId)
	}
}`
